export default __webpack_public_path__ + "static/media/img (1).2e403cb2.jpg";